import * as React from 'react';
import CardContainer from '../../common/CardContainer';
import Button from '../../controls/forms/redesign/FormButton';

interface ILandmanStatusCardProps {
    onStaffToProjectClick: () => void;
}

const LandmanStatusPanel: React.FC<ILandmanStatusCardProps> = (props) => {
    const badge = (status: string) => {
        return (
            <span className="badge">
                <span className="title">Status: </span>
                {status}
            </span>
        );
    };

    return (
        <CardContainer>
            <div className="status-panel bp3-elevation-1">
                {badge('Available')}
                <div className="content">Landman has never been staffed to a project</div>
                <div className="button-panel">
                    <Button intent="primary" size="medium" text="Staff to Project" onClick={props.onStaffToProjectClick} />
                </div>
            </div>
        </CardContainer>
    );
};

export default LandmanStatusPanel;



// WEBPACK FOOTER //
// ./src/components/personnel/components/LandmanStatusCard.tsx